import { BaseService } from "services/_baseService";

class FAQAdminService extends BaseService<any> {
  constructor() {
    super(`faq`);
  }
}

export default new FAQAdminService();
